var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-bar"},[_c('div',{staticClass:"mid-hd"},[_c('div',{staticClass:"logo-txt"},[_vm._v("格隆汇券商席位查询系统")])])])
}]

export { render, staticRenderFns }